import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

function SocketInstance () {
  this.channel_url = '/wss/push'
  this.stompClient = null
  this.payload = []
  this.topics = []
  this.callbacks = {}
  this.subscribes = {}
  this.timer = null
  this.relink_counter = 0
  this.status = 0
  this.socket = undefined

  // 初始化参数
  this.init = function (payload) {
    this.topics = []
    this.callbacks = {}
    this.subscribes = {}
    this.socket = undefined
    this.payload = payload
    payload.forEach((item, i) => {
      let topic = this.__buildSubscribeTopic(item.clientId, item.topic)
      this.topics.push(topic)
      this.callbacks[topic] = item.callback
    })
    this.__getSocketClient()
  }

  // 获取客户端
  this.__getSocketClient = function () {
    let socket = new SockJS(this.channel_url, null, {sessionId: this.__getSessionId()})
    this.socket = socket;
    this.stompClient = Stomp.over(socket)
    this.stompClient.debug = null
    this.stompClient.heartbeat.outgoing = 20000
    this.stompClient.heartbeat.incoming = 0
    this.__connection()
  }

  // 获取会话ID
  this.__getSessionId = function () {
    return sessionStorage.getItem('sessionId')
  }

  // 建立连接
  this.__connection = function () {
    this.stompClient.connect({}, () => {
      this.status = 1
      // 订阅业务主题
      this.topics.forEach((topic, i) => {
        let subscribe_frame = this.stompClient.subscribe(topic, this.callbacks[topic])
        this.subscribes[topic] = subscribe_frame
      })
    }, (err) => {
      console.log(err)
      this.status = 0
      this.__createRelink()
    })
  }

  // 取消订阅单个主题返回信息
  this.stopReceiveTopicMsg = function (clientId, topic) {
    let sub_topic = this.__buildSubscribeTopic(clientId, topic)
    this.subscribes[sub_topic].unsubscribe();
    delete this.subscribes[sub_topic]
    delete this.callbacks[sub_topic]
    let pos = null;
    for (let index=0; index<this.topics.length; index++){
      if (this.topics[index] == sub_topic) {
        pos = index;
        break;
      }
    }
    if (pos!=null) {
      this.topics.splice(pos,1)
    }
  }
  
  /** 
   * 取消订阅单个主题返回信息
   */
  this.stopReceiveTopicMsg2 = function (clientId, topic) {
	  
    let sub_topic = this.__buildSubscribeTopic(clientId, topic);
    if(this.subscribes != null && this.subscribes[sub_topic] != null ){
    	
    	this.subscribes[sub_topic].unsubscribe();
        delete this.subscribes[sub_topic];
    }
    
    if(this.callbacks != null &&  this.callbacks[sub_topic] != null ){
    	 delete this.callbacks[sub_topic];
    }
   
    let pos = null;
    for (let index=0; index<this.topics.length; index++){
      if (this.topics[index] == sub_topic) {
        pos = index;
        break;
      }
    }
    if (pos!=null) {
      this.topics.splice(pos,1)
    }
  }

  // 发送消息
  this.sendMsg = function (topic = this.channel_url, clientId, msg) {
    let sub_topic = this.__buildSubscribeTopic(clientId, topic)
    let userId = !!sessionStorage.getItem('user')?sessionStorage.getItem('user').userId:'user'
    this.__buildHeader(topic, clientId, userId)
    this.__send(sub_topic, msg)
  }

  this.__send = function (topic, header, msg) {
    this.stompClient.send(topic,  JSON.stringify(msg))
  }

  // 构建header
  // topic 原始业务主题
  // clientId 基于业务分发的客户端ID，默认情况clientId可以为空字符串
  // userId 登录账户ID
  this.__buildHeader = function (topic, clientId = '', userId) {
    let header = {
      topic: topic,
      clientId: clientId,
      userId: userId
    }
  }

  // 重连机制
  this.__createRelink = function () {
    if (this.relink_counter>3) {
      this.relink_counter = 0
      return false
    } else {
      this.relink_counter += 1
      this.__connection()
    }
  }

  // 动态添加订阅主题
  this.dynamicSubscribe = function (topic, clientId, callback) {
    let sub_topic = this.__buildSubscribeTopic(clientId, topic)
    this.topics.push(sub_topic)
    this.callbacks[sub_topic] = callback
    let subscribe_frame = this.stompClient.subscribe(sub_topic, callback)
    this.subscribes[sub_topic] = subscribe_frame
  }

  // 构造订阅主题
  this.__buildSubscribeTopic = function (clientId, topic) {
    return topic.replace('#', clientId)
  }

  // 修改心跳频率
  // outgoing 客户端发送心跳的频率
  // incoming 客户端接收心跳的频率
  this.editHeartBeat = function (outgoing, incoming) {
    this.stompClient.heartbeat.outgoing = outgoing
    this.stompClient.heartbeat.incoming = incoming
  }
}

export default new SocketInstance()
